import React from "react";
import { Navigate } from "react-router-dom";

function SAApplication() {
  return <Navigate to="/super/application/organisation" />;
}
export default SAApplication;
